<div class="bottom-sheet-overlay" [class.bottom-sheet-overlay--preview]="readOnly"
  [class.bottom-sheet-overlay--contained]="readOnly && containedPreview" (click)="closePopup()">
  <div class="bottom-sheet" [class.bottom-sheet--preview]="readOnly"
    [class.bottom-sheet--contained]="readOnly && containedPreview" (click)="$event.stopPropagation()">
    <ng-container *ngIf="readOnly; else manageMode">
      <div class="preview-header">
        <div class="sheet-handle"></div>
        <div class="preview-heading-row">
          <div class="preview-copy">
            <h2 class="preview-title">Fleet Members</h2>
            <p class="preview-subtitle">
              {{ totalMemberCount }} {{ totalMemberCount === 1 ? 'member' : 'members' }} in {{ fleet?.name }}
            </p>
          </div>
          <button type="button" class="close-circle-btn" (click)="closePopup()" aria-label="Close members list">
            <span>&times;</span>
          </button>
        </div>
      </div>

      <div class="preview-list-container" (scroll)="onPreviewScroll($event)">
        <div class="loading-state" *ngIf="isLoading">
          <p>Loading members...</p>
        </div>

        <div class="empty-state" *ngIf="!isLoading && sortedMembers.length === 0">
          <p>No members found in this fleet.</p>
        </div>

        <div class="preview-members-list" *ngIf="!isLoading && sortedMembers.length > 0">
          <div class="preview-member-card clickable" *ngFor="let member of sortedMembers; let i = index"
            [class.preview-member-card--accent]="i === 0 && member.role?.toLowerCase() === 'owner'"
            (click)="onMemberClick(member)">
            <div class="preview-member-main">
              <div class="avatar avatar--large">
                <img *ngIf="member.image" [src]="member.image" alt="Avatar" />
                <div *ngIf="!member.image" class="initials-placeholder">
                  <span>{{ getInitials(member.name) }}</span>
                </div>
              </div>
              <div class="preview-member-copy">
                <span class="preview-member-name">{{ member.name }}</span>
                <span class="preview-member-vessel">
                  <img src="assets/home/profile/boaticon.svg" class="preview-vessel-icon" alt="" />
                  {{ getMemberVesselName(member) }}
                </span>
              </div>
            </div>
            <span class="role-pill" *ngIf="getRoleLabel(member.role)">{{ getRoleLabel(member.role) }}</span>
          </div>
        </div>

        <div class="loading-more-state" *ngIf="isLoadingMore">
          Loading more members...
        </div>
      </div>
    </ng-container>

    <ng-template #manageMode>
      <div class="header">
        <div class="search-bar-row">
          <app-back-button ariaLabel="Close members" (clicked)="closePopup()"></app-back-button>
          <div class="search-input-container">
            <img src="assets/common_icons/search_icon.svg" class="search-icon" alt="Search" />
            <input type="text" [(ngModel)]="searchQuery" placeholder="Search For Members" />
          </div>
        </div>

        <div class="new-members-action" *ngIf="canManageMembers" (click)="openAddMembers()">
          <div class="action-btn">
            <span class="plus-icon">+</span>
            <span class="label">Manage Members ({{ members.length }})</span>
          </div>
        </div>
      </div>

      <div class="list-container">
        <div class="section-header">
          <span class="title">{{  'Fleet Members' }}</span>
          <span class="count">{{ filteredMembers.length }} {{ filteredMembers.length <= 1 ? 'Member' : 'Members' }}</span>
        </div>

        <div class="members-list">
          <div class="loading-state" *ngIf="isLoading">
            <p>Loading members...</p>
          </div>

          <div class="empty-state" *ngIf="!isLoading && filteredMembers.length === 0">
            <p>{{ searchQuery ? 'No members match your search' : 'No members found in this fleet.' }}</p>
          </div>

          <div class="member-row" *ngFor="let member of filteredMembers">
            <div class="member-info clickable" (click)="onMemberClick(member)">
              <div class="avatar">
                <img *ngIf="member.image" [src]="member.image" alt="Avatar" />
                <div *ngIf="!member.image" class="initials-placeholder">
                  <span>{{ getInitials(member.name) }}</span>
                </div>
              </div>
              <div class="details">
                <span class="name">{{ member.name }}</span>
                <span class="username">{{'@'}}{{ member.username }}</span>
                <span class="vessel">
                  <img src="assets/home/profile/boaticon.svg" class="vessel-icon" alt="" />
                  {{ getMemberVesselName(member) }}
                </span>
              </div>
            </div>
            <button class="remove-btn" *ngIf="canManageMembers && member.role !== 'owner'" (click)="removeMember(member)">Remove</button>
          </div>
        </div>
      </div>

      <app-add-members *ngIf="canManageMembers && showAddMembers" [fleet]="fleet" (close)="closeAddMembers()"
        (saved)="onMemberAdded($event)"></app-add-members>
    </ng-template>
  </div>
</div>
